// extracted by mini-css-extract-plugin
export var avatar = "LiftedTeamNames-module--avatar--23df1";
export var darken = "LiftedTeamNames-module--darken--90195";
export var franchiseLogo = "LiftedTeamNames-module--franchiseLogo--a3639";
export var franchiseName = "LiftedTeamNames-module--franchiseName--1c75b";
export var hasLogos = "LiftedTeamNames-module--hasLogos--07b55";
export var left = "LiftedTeamNames-module--left--eeb53";
export var liftedTeamNames = "LiftedTeamNames-module--liftedTeamNames--b72c7";
export var single = "LiftedTeamNames-module--single--e3956";